import { inject, Injectable, OnDestroy } from '@angular/core';
import { IResponseMetaResult, IResponseMetaResultSession, RequestService } from '@df/api/request/request.service';
import { TranslationService } from '@df/ui/translation/translation.service';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RespectSessionNoticesService implements OnDestroy {
    private translationService = inject(TranslationService);
    private requestService = inject(RequestService);

    protected subscription = new Subscription();

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    appInitialize() {
        this.subscription.add(
            this.requestService.subscribe<IResponseMetaResult>(response => {
                if (response?.result) {
                    this.onResult(response.result);
                }
            })
        );
    }

    onResult(result: IResponseMetaResult | any): void {
        const session: IResponseMetaResultSession | undefined = result?.session;

        if (session && session.message) {
            window.alert(this.translationService.translate(session.message));
        }
    }
}
